var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.854 4.316c.38 0 .571.459.302.729l-.663.664c-.082.078-.189.125-.302.125H5.515c-.552 0-1 .447-1 1v10.898c0 .553.448 1 1 1h10.879c.552 0 1-.447 1-1v-4.138c0-.113.046-.22.124-.302l.663-.664c.27-.267.728-.078.728.302v5.613c0 .942-.763 1.707-1.704 1.707h-12.5C3.763 20.25 3 19.485 3 18.543V6.023c0-.942.763-1.707 1.705-1.707zm3.387-.372l3.315 3.32c.259.259.259.679 0 .938l-8.618 8.63c-.124.124-.292.194-.468.194H9.155c-.366 0-.663-.297-.663-.664v-3.319c0-.176.07-.345.195-.47l8.617-8.629c.259-.259.679-.259.937 0zm-.468 1.409l-7.955 7.965v2.38h2.377l7.955-7.965-2.377-2.38z",
    transform: "translate(-40 -666) translate(40 666)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.3bb7b4c5.svg";
export { ForwardRef as ReactComponent };